import React, { useEffect, useRef } from "react";
import { FiUser, FiSettings, FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import "./ProfileMenu.css";
import { toast } from "react-toastify";

function getStoredUser() {
  const ls = localStorage.getItem("user");
  const ss = sessionStorage.getItem("user");
  try {
    return JSON.parse(ls || ss) || null;
  } catch {
    return null;
  }
}

function ProfileMenu({ onLogout, onClose }) {
  const navigate = useNavigate();
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose?.();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const handleConfigClick = () => {
    const storedUser = getStoredUser();
    const rol = storedUser?.rol?.toString().toLowerCase();

    if (rol === "admin") {
      navigate("/hub");
    } else {
      toast.info("¡Lo sentimos! No puedes acceder a este espacio.");
    }

    onClose?.();
  };

  return (
    <div className="profile-menu" ref={menuRef}>
      <ul>
        <li
          onClick={() => {
            navigate("/perfil");
            onClose?.();
          }}
        >
          <FiUser className="icon" /> Ver perfil
        </li>

        <li onClick={handleConfigClick}>
          <FiSettings className="icon" /> Configuración
        </li>

        <li
          onClick={() => {
            onLogout?.();
            onClose?.();
          }}
          className="logout"
        >
          <FiLogOut className="icon" /> Cerrar sesión
        </li>
      </ul>
    </div>
  );
}

export default ProfileMenu;
